import { Component, OnInit, Inject } from '@angular/core';
import { Validators, FormControl, FormGroup } from '@angular/forms';
import { LoadingService } from '../../../../../shared/services/loading.service';
import { ReportBuilderService } from '../report-builder.service';
import { NotificationsService } from 'angular2-notifications';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
    selector: 'send-report-modal',
    templateUrl: './send-report-modal.component.html',
    styleUrls: ['./send-report-modal.component.scss']
})
export class SendReportModalComponent implements OnInit {

    emailAddress: string = "";
    validEmailString: boolean = false;
    customerName: string = "";

    reportUoM: string = "mm";
    MSInspectionID: number = 0;
    saving: boolean = false;

    emailForm: FormGroup;
    customerNameInput: FormControl;
    emailInput: FormControl;

    styleId:number


    constructor(
        private dialogRef: MatDialogRef<SendReportModalComponent>,
        private _loading: LoadingService,
        private _rbService: ReportBuilderService,
        private _notify: NotificationsService,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) { }

    ngOnInit() {
        this.MSInspectionID = this.data.MSInspectionID;
        this.reportUoM = this.data.ReportUoM;
        this.styleId=this.data.styleId;
        this.customerNameInput = new FormControl('', [
            Validators.required,
        ]);

        this.emailInput = new FormControl('', [
            Validators.required,          
        ]);
        
        this.emailForm = new FormGroup({
            customerNameInput: this.customerNameInput,
            emailInput: this.emailInput,
        });
    }

    checkEmailAddress() {
        var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        this.validEmailString = re.test(String(this.emailAddress).toLowerCase());
    }

    saveChanges() {
        console.log('styleid', this.styleId)
        this.saving = true;
        this._loading.startLoading();

        this._rbService.SendReport(this.MSInspectionID, this.emailAddress, this.customerName, this.reportUoM, this.styleId).subscribe(r2 => {
            this._loading.finishedLoading();
            this.saving = false;
            if (r2 != null && r2 == true) {
                this.dialogRef.close();
                this._notify.success("Successfully sent report.")
            } else {
                this._notify.warn("Failed to send report!")

            }
        });
        // if (this.validEmailString && this.emailAddress.length > 0) {
        //     this.dialogRef.close({
        //         data: this.emailAddress
        //     });
        // }
    }

    onCloseClick(): void {
        this.dialogRef.close();
    }
}
